module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component.css
// module id = ./src/app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component.css
// module chunks = main